import i18next from 'i18next';
import type { i18n } from 'i18next';
import { App, Ref, ref } from 'vue';

const i18n: Ref<i18n> = ref({} as i18n);

export default () => {
  const createI18nService = (app: App) => {
    i18n.value = i18next.createInstance({
      returnObjects: true,
      interpolation: {
        prefix: '{',
        suffix: '}',
        escapeValue: false,
      },
    });
    i18n.value.init({});
    if (app) {
      app.config.globalProperties.$t = i18n.value.t.bind(i18next);
    }
  };

  return {
    i18n,
    createI18nService,
  };
};
